
(() => {
  const roots = document.querySelectorAll('[id^="tmc-topps-store-"]');
  if (!roots.length) return;

  const revealSelector = [
    '.kicker',
    'h1',
    'h2',
    'h3',
    '.hero-copy',
    '.section-head',
    '.collection-card',
    '.product-card',
    '.last-card',
    '.hobby-card',
    '.editorial-card',
    '.newsletter',
    '.banner-card'
  ].join(',');

  const items = [];

  roots.forEach(root => {
    root.querySelectorAll(revealSelector).forEach((el, index) => {
      el.classList.add('tmc-motion-reveal');
      el.classList.add(`tmc-motion-delay-${(index % 5) + 1}`);
      items.push(el);
    });
  });

  if (!('IntersectionObserver' in window)) {
    items.forEach(el => el.classList.add('tmc-motion-in'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('tmc-motion-in');
        io.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -8% 0px'
  });

  items.forEach(el => io.observe(el));

  // Tilt suave solo en desktop para cards principales
  const canTilt = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if (!canTilt) return;

  const tiltCards = [];
  roots.forEach(root => {
    root.querySelectorAll('.collection-card,.product-card,.last-card,.hobby-card').forEach(card => {
      tiltCards.push(card);
    });
  });

  tiltCards.forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width - 0.5) * 4;
      const y = ((e.clientY - rect.top) / rect.height - 0.5) * -4;
      card.style.transform = `translateY(-9px) rotateX(${y}deg) rotateY(${x}deg)`;
    });

    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });
})();


/* TMC Cambio AQ — Home premium motion controller */
(() => {
  const roots = document.querySelectorAll('[id^="tmc-topps-store-"]');
  if (!roots.length) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  roots.forEach((root) => {
    // Agregar orbit cards decorativas al hero sin tocar Liquid
    const hero = root.querySelector('.hero, .main-hero, .hero-section');
    if (hero && !hero.querySelector('.tmc-home-orbit')) {
      ['one', 'two', 'three'].forEach((name) => {
        const orbit = document.createElement('span');
        orbit.className = `tmc-home-orbit ${name}`;
        orbit.setAttribute('aria-hidden', 'true');
        hero.appendChild(orbit);
      });
    }

    // Cursor spotlight + parallax variables
    const canPointer = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if (canPointer) {
      root.addEventListener('pointermove', (e) => {
        const rect = root.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / Math.max(rect.height, 1)) * 100;
        const xNum = (x - 50) * 0.12;
        const yNum = (y - 50) * 0.10;

        root.style.setProperty('--tmc-cursor-x', `${x}%`);
        root.style.setProperty('--tmc-cursor-y', `${y}%`);
        root.style.setProperty('--tmc-cursor-x-num', xNum.toFixed(2));
        root.style.setProperty('--tmc-cursor-y-num', yNum.toFixed(2));
      }, { passive: true });
    }

    // Stagger más natural en cards
    root.querySelectorAll('.product-card,.last-card,.collection-card').forEach((card, index) => {
      card.style.setProperty('--tmc-card-delay', `${Math.min(index * 0.045, 0.35)}s`);
    });

    // Scroll depth sutil para secciones
    let ticking = false;
    const updateScrollDepth = () => {
      const rect = root.getBoundingClientRect();
      const viewport = window.innerHeight || 1;
      const progress = Math.min(Math.max((viewport - rect.top) / (rect.height + viewport), 0), 1);
      root.style.setProperty('--tmc-scroll-depth', `${(progress * 24).toFixed(2)}px`);
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDepth);
        ticking = true;
      }
    }, { passive: true });

    updateScrollDepth();
  });
})();


/* TMC Cambio AX2 — remover placeholders grises vacíos si el JS anterior los crea */
(() => {
  const removeOrbitCards = () => {
    document.querySelectorAll('[id^="tmc-topps-store-"] .tmc-home-orbit').forEach(el => el.remove());
  };
  removeOrbitCards();
  document.addEventListener('DOMContentLoaded', removeOrbitCards);
  setTimeout(removeOrbitCards, 300);
  setTimeout(removeOrbitCards, 900);
})();
